import { render, staticRenderFns } from "./CampaignSchool.vue?vue&type=template&id=61141abe&"
import script from "./CampaignSchool.vue?vue&type=script&lang=js&"
export * from "./CampaignSchool.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSchool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports